export default __webpack_public_path__ + "static/media/Sellers tab_preparing the house.947a2687.jpg";